import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Grid, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader } from '@chakra-ui/react';
import { LanguageEnum } from '@whitbread-eos/api';
import { Bell, Button, DismissDarkGrey, Icon } from '@whitbread-eos/atoms';
import { renderSanitizedHtml } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { buttonsStyle, delimiterModalStyle, descriptionStyle, headerContentStyle, headerTitleStyle, modalBodyBoxStyle, modalBodyStyle, modalCloseButtonStyle, modalContentStyle, wrapperStyles, closeButtonStyle, allowButtonDE, allowButtonGB } from './ConsentNotificationModal.style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ConsentNotificationModalComponent(_ref) {
  var isModalVisible = _ref.isModalVisible,
    onConsentModalClose = _ref.onConsentModalClose,
    onConsentModalAllow = _ref.onConsentModalAllow,
    onConsentModalDeny = _ref.onConsentModalDeny,
    language = _ref.language;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function renderModalContent() {
    return _jsxs(Flex, _objectSpread(_objectSpread({
      "data-testid": "pi-notification-permission-popup-container"
    }, wrapperStyles), {}, {
      children: [_jsx(Box, _objectSpread(_objectSpread({
        "data-testid": "pi-notification-permission-popup-description"
      }, descriptionStyle), {}, {
        sx: {
          a: {
            fontWeight: 'var(--chakra-fontWeights-medium)',
            textDecoration: 'underline'
          }
        },
        children: renderSanitizedHtml(t('pushNotifications.popup.description'))
      })), _jsxs(Flex, _objectSpread(_objectSpread({}, buttonsStyle), {}, {
        children: [_jsx(Button, _objectSpread(_objectSpread({}, language === LanguageEnum.GERMAN ? allowButtonDE : allowButtonGB), {}, {
          "data-testid": "pi-notification-permission-popup-allow-btn",
          size: "sm",
          variant: "secondary",
          mr: "md",
          onClick: onConsentModalAllow,
          children: t('pushNotifications.popup.allow')
        })), _jsx(Button, _objectSpread(_objectSpread({
          "data-testid": "pi-notification-permission-popup-deny-btn",
          size: "sm",
          width: "188px",
          variant: "tertiary",
          onClick: onConsentModalDeny
        }, closeButtonStyle), {}, {
          children: t('pushNotifications.popup.dontAllow')
        }))]
      }))]
    }));
  }
  return _jsx(Modal, {
    "data-testid": "pi-notification-permission-popup-chakra-modal",
    scrollBehavior: "inside",
    isCentered: false,
    isOpen: isModalVisible,
    onClose: onConsentModalClose,
    closeOnOverlayClick: false,
    blockScrollOnMount: false,
    trapFocus: false,
    children: _jsxs(ModalContent, _objectSpread(_objectSpread({
      "data-testid": "pi-notification-permission-popup-modal-content"
    }, modalContentStyle), {}, {
      width: {
        mobile: '90%',
        sm: '27.5rem'
      },
      containerProps: {
        width: {
          mobile: '100%',
          sm: '0rem'
        },
        height: {
          mobile: '0rem'
        }
      },
      children: [_jsx(ModalHeader, {
        "data-testid": "pi-notification-permission-popup-modal-header",
        width: '100%',
        children: _jsxs(Flex, {
          flexDir: "column",
          children: [_jsxs(Grid, _objectSpread(_objectSpread({}, headerContentStyle), {}, {
            children: [_jsxs(Flex, _objectSpread(_objectSpread({}, headerTitleStyle), {}, {
              "data-testid": "pi-notification-permission-popup-modal-title",
              children: [_jsx(Icon, {
                svg: _jsx(Bell, {}),
                mr: "sm"
              }), t('pushNotifications.popup.title')]
            })), _jsx(ModalCloseButton, _objectSpread(_objectSpread({
              "data-testid": "pi-notification-permission-popup-close-btn"
            }, modalCloseButtonStyle), {}, {
              children: _jsx(Icon, {
                svg: _jsx(DismissDarkGrey, {
                  transform: "scale(1.1)"
                })
              })
            }))]
          })), _jsx(Box, _objectSpread({
            "data-testid": "pi-notification-permission-popup-delimiter"
          }, delimiterModalStyle))]
        })
      }), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "pi-notification-permission-popup-modal-body"
      }, modalBodyStyle), {}, {
        children: _jsx(Box, _objectSpread(_objectSpread({
          overflowX: "hidden"
        }, modalBodyBoxStyle), {}, {
          children: renderModalContent()
        }))
      }))]
    }))
  });
}